import { Link } from "gatsby";
import React from "react";
import LatestArticlesSection from "./LatestArticlesSection";

const LatestArticles = ({
  articles,
  title = "",
  description,
  noTopPadding = false,
}) => {
  return (
    <section className="relative box-border z-[1]">
      <div
        className={`text-black stories after:z-0 ${
          noTopPadding ? "pb-[30px] lg:pb-[90px]" : "py-[30px] lg:py-[90px]"
        }`}
      >
        {/* Heading */}
        <div className="px-5 xl:px-20 relative z-[2] flex flex-col items-start md:flex-row md:items-center justify-between">
          <div className="mb-[30px]">
            <h2 className="text-3xl leading-[45px] md:text-[40px] md:leading-[60px] font-bold tracking-wide">
              {title}
            </h2>
            {description ? (
              <p className="mt-5 max-w-[700px] text-base">{description}</p>
            ) : (
              <p className="mt-5 max-w-[700px] text-base">
                Check out the latest posts from The Campfire contributors.{" "}
                <Link to="/pages/contribute" className="text-[#551A8B]">
                  <strong>Click here</strong>
                </Link>{" "}
                to submit your story and get featured.
              </p>
            )}
          </div>
          <Link
            to="/blog"
            className="font-bold leading-7 tracking-wide underline underline-offset-2"
          >
            View all articles
          </Link>
        </div>
        {/* Latest Articles */}
        <LatestArticlesSection articles={articles} />
      </div>
    </section>
  );
};

export default LatestArticles;
